import React from "react";

import {CircularProgressbar} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import {i18n} from "translate/i18n";

import fileDownload from 'js-file-download'
import {delDocument, getFile} from "services/Files.service";
import {swalQuestion} from "../Swal";
import {useQueryClient} from "react-query";
import {toast} from "react-toastify";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import PT from "../../assets/img/pt-mini.png";
import EN from "../../assets/img/en-mini.png";
import {setLog} from "../../services/Logs.service";
import {useUser} from "../../store/providers/app";

function FileList({files, isFetching, currentPage, search, handleDeleteNew}) {

    const { user } = useUser()

    const handleDownload = (url, filename) => {
        const response = getFile(url);
        fileDownload(response.data, filename)
    }

    const clientQuery = useQueryClient()

    const handleDelete = (id, filename) => {
        swalQuestion(`${i18n.t('questions.deleteArchive')} <b>${filename}</b>?`).then(res => {
            if (res.isConfirmed) {
                delDocument(id).then(res => {
                    if (res.data.success) {
                        toast.success(i18n.t('success.deleteSuccess'))
                        clientQuery.invalidateQueries(['documents', currentPage, search])

                        setLog({
                            'title': 'DELETE_DOCUMENT',
                            'description': 'Exclusão de arquivo: ' + filename,
                            'username': user?.username,
                        });

                    } else {
                        toast.error(i18n.t('error.badRequest'))
                    }
                })
            }
        })
    }

    const getExt = (filename) => {
        return filename.split('.').pop();
    }


    const handleCopyLink = (link) => {
        navigator.clipboard.writeText(link)
        toast.success('Link copiado para área de transferência!')
    }

    return (
        <table className={`table mb-0 align-middle`}>
            <thead className="bg-primary text-uppercase text-sm">
            <tr>
                <th className="py-4" colSpan={2}>{i18n.t('label.archive')}</th>
                <th className="py-4">{i18n.t('label.category')}</th>
                <th className="py-4">{i18n.t('label.title')}/{i18n.t('label.description')}</th>
                <th className="py-4">{i18n.t('label.user')}</th>
                <th className="py-4">{i18n.t('label.language')}</th>
                <th/>
            </tr>
            </thead>

            <tbody className="border-bottom-0">
            {!files.length &&
                <tr>
                    <td>{i18n.t('upload.tableRecords')}</td>
                </tr>
            }

            {files.map((file, index) => (
                <React.Fragment key={file.id}>
                    <tr className={`${isFetching && "text-muted"}`}>
                        <td width={10}>
                            <i className={`bi bi-filetype-${getExt(file.filename)} fs-2 text-primary`}/>
                        </td>

                        <td>
                            <p className="mb-0 text-muted bold-500 text-sm">{i18n.t('label.archive')}</p>
                            <p className="mb-0 text-sm">{file.filename}</p>
                        </td>

                        <td>
                            <p className="mb-0 text-muted bold-500 text-sm">{file.category}</p>
                        </td>

                        <td>
                            <p className="mb-0 text-muted bold-500 text-sm">{file.title}</p>
                            <p className="mb-0 text-sm">{file.description}</p>
                        </td>

                        <td className="text-sm">
                            <p className="mb-0 mt-0 bold-500">{file.username}</p>
                            <p className="mb-0 text-muted"> {file.created_at} </p>
                        </td>

                        <td>{file.language === 'pt-BR'
                            ? <img src={PT} width={25} alt="pt-BR"/>
                            : <img src={EN} width={25} alt="en-US"/>
                            }
                        </td>

                        <td>
                            {!file.uploaded && !file.error &&
                                <CircularProgressbar
                                    styles={{
                                        root: {width: 30},
                                        path: {stroke: 'green'}
                                    }}
                                    strokeWidth={8}
                                    value={file.progress}
                                />
                            }

                            {file.uploaded &&
                                <span className="d-flex gap-2 float-end">
                                    <OverlayTrigger overlay={<Tooltip
                                        id="tooltip-disabled">{i18n.t('label.copyLink')}</Tooltip>}>
                                         <button className="btn btn-sm btn-outline-info" onClick={() => handleCopyLink(file.url)}>
                                            <i className="bi bi-link-45deg"/>
                                        </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger overlay={<Tooltip
                                        id="tooltip-disabled">{i18n.t('label.deleteArchive')}</Tooltip>}>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => {
                                            handleDelete(file.id, file.filename)
                                        }}>
                                            <i className="bi bi-trash"/>
                                        </button>
                                    </OverlayTrigger>


                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{i18n.t('label.downloadArchive')}</Tooltip>}>
                                        <button className="btn btn-sm btn-outline-primary" onClick={() => {
                                            handleDownload(file.url, file.filename)
                                        }}>
                                            <i className="bi bi-download"/>
                                        </button>
                                    </OverlayTrigger>
                                </span>
                            }

                            {!file.uploaded &&
                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{i18n.t('label.cancelArchive')}</Tooltip>}>
                                    <button className="btn btn-sm btn-outline-danger mx-2" onClick={() => {
                                        handleDeleteNew(index, file.id)
                                    }}>
                                        <i className="bi bi-x"/>
                                    </button>
                                </OverlayTrigger>
                            }

                            {file.error &&
                                <i className="bi bi-x-circle text-danger size-icon-2" style={{display: "flex"}}/>}
                        </td>
                    </tr>
                </React.Fragment>
            ))}
            </tbody>
        </table>
    )
}

export default FileList
